import styled from "styled-components";
import { COLORS } from "./style";

export const Line = styled.hr`
  background-color: ${COLORS.BLACK};
  margin: 0.5rem 0;
`;
